import {
  SET_FILTER, SET_BUILDER, SET_PIPELINE,
  CONTENT_DID_MOUNT,
  FILTER_OPEN, FILTER_CLOSE,
  MENU_OPEN, MENU_CLOSE,
  PIPELINE_OPEN, PIPELINE_CLOSE, PIPELINE_SIDE,
  PIPELINE_SAVED_SHOW_OWN, PIPELINE_SAVED_SHOW_COMMON,
} from './types';

export const setFilter = payload => ({
  type: SET_FILTER,
  payload,
});

export const setBuilder = payload => ({
  type: SET_BUILDER,
  payload,
});

export const setPipeline = payload => ({
  type: SET_PIPELINE,
  payload,
});

export const contentDidMount = () => ({
  type: CONTENT_DID_MOUNT,
});

export const filterOpen = () => ({
  type: FILTER_OPEN,
});

export const filterClose = () => ({
  type: FILTER_CLOSE,
});

export const menuOpen = () => ({
  type: MENU_OPEN,
});

export const menuClose = () => ({
  type: MENU_CLOSE,
});

export const pipelineOpen = () => ({
  type: PIPELINE_OPEN,
});

export const pipelineClose = () => ({
  type: PIPELINE_CLOSE,
});

export const pipelineSide = side => ({
  type: PIPELINE_SIDE,
  side,
});

export const pipelineSavedShowOwn = show => ({
  type: PIPELINE_SAVED_SHOW_OWN,
  show,
});

export const pipelineSavedShowCommon = show => ({
  type: PIPELINE_SAVED_SHOW_COMMON,
  show,
});
